import axios from "axios";

export const getParametriApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/parametro/`, {
        params: params,
    });
}

export const getParametroByIdApi = (idParametro, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/parametro/${idParametro}`, {
        params: params,
    });
}

export const aggiornaParametroApi = (idParametro, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/parametro/${idParametro}`, payload, {
        params: params,
    });
}